import { render, staticRenderFns } from "./DemoUserRoleNotification.vue?vue&type=template&id=c4dacde2"
import script from "./DemoUserRoleNotification.vue?vue&type=script&lang=js"
export * from "./DemoUserRoleNotification.vue?vue&type=script&lang=js"
import style0 from "./DemoUserRoleNotification.vue?vue&type=style&index=0&id=c4dacde2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports